import { Button } from "@shared/ui/button";

interface ConsumerDetailsReviewProps {
  data?: any;
  onEdit?: () => void;
}

export function ConsumerDetailsReview({
  data,
  onEdit,
}: ConsumerDetailsReviewProps) {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-gray-900">Consumer Details</h2>
        <Button variant="outline" size="sm" onClick={onEdit}>
          Edit
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* First Name */}
        <div>
          <p className="text-sm text-gray-600 mb-1">First Name</p>
          <p className="text-base text-gray-900 font-medium">
            {data?.first_name ||
              data?.firstName ||
              data?.primary_consumer?.first_name ||
              "Not specified"}
          </p>
        </div>

        {/* Last Name */}
        <div>
          <p className="text-sm text-gray-600 mb-1">Last Name</p>
          <p className="text-base text-gray-900 font-medium">
            {data?.last_name ||
              data?.lastName ||
              data?.primary_consumer?.last_name ||
              "Not specified"}
          </p>
        </div>

        {/* Email */}
        <div>
          <p className="text-sm text-gray-600 mb-1">Email</p>
          <p className="text-base text-gray-900 font-medium">
            {data?.email ||
              data?.primary_consumer?.email ||
              "Not specified"}
          </p>
        </div>

        {/* Phone Number */}
        <div>
          <p className="text-sm text-gray-600 mb-1">Phone Number</p>
          <p className="text-base text-gray-900 font-medium">
            {data?.phone_number ||
              data?.phoneNumber ||
              data?.contact_number ||
              data?.contactNumber ||
              data?.mobile_number ||
              data?.primary_consumer?.contact_number ||
              "Not specified"}
          </p>
        </div>

        {/* Account Category */}
        <div>
          <p className="text-sm text-gray-600 mb-1">Category</p>
          <p className="text-base text-gray-900 font-medium capitalize">
            {data?.account_category_display ||
              data?.account_category ||
              data?.categoryDisplay ||
              data?.category ||
              data?.primary_consumer?.category_display ||
              "Not Specified"}
          </p>
        </div>

        {/* Account Sub-Category */}
        <div>
          <p className="text-sm text-gray-600 mb-1">Sub Category</p>
          <p className="text-base text-gray-900 font-medium">
            {(
              data?.account_sub_category_display ||
              data?.account_sub_category ||
              data?.subCategoryDisplay ||
              data?.subCategory ||
              data?.primary_consumer?.sub_category_display ||
              ""
            )
              ?.split("_")
              .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ") || "Not specified"}
          </p>
        </div>

        {/* SSN/Tax ID */}
        <div>
          <p className="text-sm text-gray-600 mb-1">SSN/Tax ID</p>
          <p className="text-base text-gray-900 font-medium">
            {data?.ssn ||
              data?.ssn_encrypted ||
              data?.taxId ||
              data?.primary_consumer?.ssn_encrypted ||
              "Not specified"}
          </p>
        </div>

        {/* Date of Birth */}
        <div>
          <p className="text-sm text-gray-600 mb-1">Date of Birth</p>
          <p className="text-base text-gray-900 font-medium">
            {data?.date_of_birth ||
              data?.dateOfBirth ||
              data?.dob ||
              data?.primary_consumer?.date_of_birth ||
              "Not specified"}
          </p>
        </div>

        {/* VIP Designation */}
        <div>
          <p className="text-sm text-gray-600 mb-1">VIP Designation</p>
          <p className="text-base text-gray-900 font-medium">
            {data?.vip_designation || data?.is_vip || data?.isVip || data?.primary_consumer?.is_vip
              ? "Yes"
              : "No"}
          </p>
        </div>
      </div>

      {/* Co-Applicant Section */}
      {data?.add_co_applicant && data?.co_applicant && (
        <div className="mt-6 pt-6 border-t border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">
            Co-Applicant Details
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
  <p className="text-sm text-gray-600 mb-1">Secondary Relationship</p>
  <p className="text-base text-gray-900 font-medium">
    {data.co_applicant?.relationship_display || "Not specified"}
  </p>
</div>
            <div>
              <p className="text-sm text-gray-600 mb-1">First Name</p>
              <p className="text-base text-gray-900 font-medium">
                {data.co_applicant.first_name || "Not specified"}
              </p>
            </div>
            <div>
              <p className="text-sm text-gray-600 mb-1">Last Name</p>
              <p className="text-base text-gray-900 font-medium">
                {data.co_applicant.last_name || "Not specified"}
              </p>
            </div>
            <div>
              <p className="text-sm text-gray-600 mb-1">Email</p>
              <p className="text-base text-gray-900 font-medium">
                {data.co_applicant.email || "Not specified"}
              </p>
            </div>
            <div>
              <p className="text-sm text-gray-600 mb-1">Phone Number</p>
              <p className="text-base text-gray-900 font-medium">
                {data.co_applicant.phone_number || "Not specified"}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}